<template>
    <div class="login" v-if="isGuest">
        <div class="login__title">
            <span>{{ $t("login.title") }}</span>
        </div>
        <form class="login__form" v-if="!isAuthenticated" @submit.prevent.stop="submit">
            <sah-input
                :autofocus="true"
                :error-message="isLoginError ? $t('login.error') : ''"
                :label="$tc('login.enterApiKey')"
                :placeholder="$tc('login.apiKey')"
                v-model="apiKey"
                @input="change"
                @keydown.enter.stop="submit"
            ></sah-input>
            <sah-button class="login__button_submit" type="submit">
                {{ $tc("login.submit") }}
            </sah-button>
        </form>
        <div class="login__content" v-else>{{ $tc("login.loggedin") }}</div>
    </div>
</template>

<script>
import {store, SahInput, SahButton} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions, mapGetters} = createNamespacedHelpers("arcman");
/**
 * Renderer for the landing page of the application
 */
export default {
    name: "login",
    components: {SahInput, SahButton},
    data: () => ({
        apiKey: null,
    }),
    computed: {
        ...mapGetters(["isLoginError", "isAuthenticated", "isGuest"]),
    },
    methods: {
        ...mapActions({login: "LOGIN", change: "API_KEY_CHANGE"}),
        submit() {
            this.login({
                apiKey: this.apiKey,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.login::v-deep {
    @apply w-4/5 absolute rounded overflow-hidden shadow-xl border border-solid pb-12;
    @include position-center;
    color: $text-application-color;
    font-size: $font-small;
    background-color: $background-application-color;
    border-color: $border-card-color;
    @screen md {
        @apply w-3/5;
    }
    @screen xl {
        @apply w-2/5;
    }

    &.animation-enter,
    &.animation-leave-to {
        @apply opacity-0;
        transform: translate(-50%, -100%);
    }

    &.animation-enter-to,
    &.animation-leave {
        @apply opacity-100;
        @include position-center;
    }

    &.animation-enter-active,
    &.animation-leave-active {
        transition: transform 800ms, opacity 800ms;
    }

    .login__title {
        @apply text-center py-4 relative;
        background-color: $background-card-header-color;
        color: $text-card-header-color;
        font-size: $font-large;
    }

    .login__form,
    .login__content {
        @apply w-full px-8 text-center mt-8;
    }

    .login__button_submit {
        @apply border border-solid mt-4;
        background-color: $background-button-primary-color;
        border-color: $border-button-primary-color;
    }

    .sah-input {
        @apply mb-4;
    }

    .sah-input__label {
        @apply block mb-4 text-left font-bold;
    }
}
</style>
